import React, { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { env } from "../config";
import * as Actions from "../redux/actions";
import Loader from "../components/Loader";
import { useLocation } from "react-router";
import Footer from "../components/Footer";
const CompanyPageIntro = React.lazy(
  () => import("../components/CompanyPageIntro")
);
const Capabilities = React.lazy(() => import("../components/CapabilitiesHome"));
const Different = React.lazy(() => import("../components/DifferentHome"));
const History = React.lazy(() => import("../components/HistoryHome"));
const ContactUsSection = React.lazy(
  () => import("../components/ContactUsSection")
);

function CompanyPage() {
  const CompanyData: any = useSelector(
    (state: any) => state?.Page?.CompanyPageContent
  );

  const dispatch = useDispatch();

  let url = "/api/company-page-content?populate=deep";
  let action = Actions.CompanypageAction;

  useEffect(() => {
    if (Object.keys(CompanyData).length === 0) {
      setTimeout(() => {
        (async () => {
          await axios
            .get(`${env}${url}`)
            .then(function (response) {
              dispatch(action(response?.data?.data?.attributes));
            })
            .catch((error: any) => {
              console.log("error", error);
            });
        })();
      }, 0);
    }
    window.scrollTo({
      top: 0,
      left: 1,
      behavior: "smooth",
    });
  }, [dispatch]);

  const isLoading = Object.keys(CompanyData).length === 0;

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Suspense fallback={<Loader />}>
        <CompanyPageIntro ContactPageIntro={CompanyData?.CompanyPageIntro} />

        <Capabilities
          HomeIntroContent={CompanyData?.CompanyPageIntroDescription}
        />

        <Different HomeFeatures={CompanyData?.CompanyFeatures} />

        <History HomeHistorySection={CompanyData?.CompanyHistorySection} />

        <ContactUsSection ContactUsSection={CompanyData?.ConnectSection} />
        <Footer />
      </Suspense>
    </>
  );
}

export default CompanyPage;
